
export const SET_CUSTOMER_TRACKING_RESPONSE = "SET_CUSTOMER_TRACKING_RESPONSE";   
export const SET_CUSTOMER_TRACKING_RESET = "SET_CUSTOMER_TRACKING_RESET";   
export const SET_BRANCH_TRACKING_RESPONSE = "SET_BRANCH_TRACKING_RESPONSE";   